"use client";

import React from "react";

const cards = [
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="18"
        viewBox="0 0 22 18"
        fill="none"
      >
        <path
          d="M11 18L4 14.2V8.2L0 6L11 0L22 6V14H20V7.1L18 8.2V14.2L11 18ZM11 9.7L17.85 6L11 2.3L4.15 6L11 9.7ZM11 15.725L16 13.025V9.25L11 12L6 9.25V13.025L11 15.725Z"
          fill="#FFBA08"
        />
      </svg>
    ),
    text: "Candidates should hold a bachelor's degree in commerce, accounting, or a related field",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          d="M4 14H6V9H4V14ZM12 14H14V4H12V14ZM8 14H10V11H8V14ZM8 9H10V7H8V9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM2 16H16V2H2V16ZM2 2V16V2Z"
          fill="#FFBA08"
        />
      </svg>
    ),
    text: "Candidates must meet the 150 credit hour requirement (depending on the state board)",
  },
  {
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
      >
        <path
          d="M17 18C16.35 18 15.7667 17.8125 15.25 17.4375C14.7333 17.0625 14.375 16.5833 14.175 16H9C7.9 16 6.95833 15.6083 6.175 14.825C5.39167 14.0417 5 13.1 5 12C5 10.9 5.39167 9.95833 6.175 9.175C6.95833 8.39167 7.9 8 9 8H11C11.55 8 12.0208 7.80417 12.4125 7.4125C12.8042 7.02083 13 6.55 13 6C13 5.45 12.8042 4.97917 12.4125 4.5875C12.0208 4.19583 11.55 4 11 4H5.825C5.60833 4.58333 5.24583 5.0625 4.7375 5.4375C4.22917 5.8125 3.65 6 3 6C2.16667 6 1.45833 5.70833 0.875 5.125C0.291667 4.54167 0 3.83333 0 3C0 2.16667 0.291667 1.45833 0.875 0.875C1.45833 0.291667 2.16667 0 3 0C3.65 0 4.22917 0.1875 4.7375 0.5625C5.24583 0.9375 5.60833 1.41667 5.825 2H11C12.1 2 13.0417 2.39167 13.825 3.175C14.6083 3.95833 15 4.9 15 6C15 7.1 14.6083 8.04167 13.825 8.825C13.0417 9.60833 12.1 10 11 10H9C8.45 10 7.97917 10.1958 7.5875 10.5875C7.19583 10.9792 7 11.45 7 12C7 12.55 7.19583 13.0208 7.5875 13.4125C7.97917 13.8042 8.45 14 9 14H14.175C14.3917 13.4167 14.7542 12.9375 15.2625 12.5625C15.7708 12.1875 16.35 12 17 12C17.8333 12 18.5417 12.2917 19.125 12.875C19.7083 13.4583 20 14.1667 20 15C20 15.8333 19.7083 16.5417 19.125 17.125C18.5417 17.7083 17.8333 18 17 18ZM3 4C3.28333 4 3.52083 3.90417 3.7125 3.7125C3.90417 3.52083 4 3.28333 4 3C4 2.71667 3.90417 2.47917 3.7125 2.2875C3.52083 2.09583 3.28333 2 3 2C2.71667 2 2.47917 2.09583 2.2875 2.2875C2.09583 2.47917 2 2.71667 2 3C2 3.28333 2.09583 3.52083 2.2875 3.7125C2.47917 3.90417 2.71667 4 3 4Z"
          fill="#FFBA08"
        />
      </svg>
    ),
    text: "Additional credits may be required for Indian students – Miles provides a 30-credit bridge course to make you eligible",
  },
];

const CPACourseEligibility = () => {
  return (
    <section className="relative w-full overflow-hidden bg-black md:py-[50px] py-6">
      {/* Desktop background */}
      <div
        className="absolute inset-0 hidden bg-cover bg-center bg-no-repeat md:block"
        style={{
          backgroundImage:
            "url('https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-course/CPA_Course_Eligibility_desk.webp')",
        }}
      />
      {/* Mobile background */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat md:hidden"
        style={{
          backgroundImage:
            "url('https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-course/CPA_Course_Eligibility_mob.webp')",
        }}
      />

      {/* Content */}
      <div className="relative z-10 main_container">
        {/* Heading */}
        <h2 className="mb-4 text-left text-2xl font-bold leading-tight text-white md:mb-6 md:text-center lg:text-[32px]">
          <span className="text-[#FFBA08]">CPA</span> Course Eligibility
        </h2>

        {/* Subtitle */}
        <p className="mb-6 text-left text-xs md:text-sm font-semibold leading-relaxed text-white md:mx-auto md:mb-10 md:max-w-lg md:text-center">
          Before enrolling in the CPA course, it&apos;s important to understand
          the eligibility details first. Here&apos;s a quick overview.
        </p>

        {/* Cards */}
        <div className="mb-10 flex flex-col gap-4 md:mb-12 md:flex-row md:gap-5 lg:gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="flex flex-1 items-start gap-4 rounded-lg border border-white/[0.12] bg-[rgba(8,20,44,0.78)] p-4 backdrop-blur-md"
            >
              <div className="mt-0.5 flex-shrink-0">{card.icon}</div>
              <p className="text-sm font-medium leading-relaxed text-white">
                {card.text}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom note */}
        <p className="text-left text-sm font-bold text-white md:mx-auto md:max-w-lg md:text-center">
          Miles Education assesses your transcript and creates a custom roadmap
          so you qualify without any guesswork needed.
        </p>
      </div>
    </section>
  );
};

export default CPACourseEligibility;
